import { Injectable } from '@angular/core';
import gql from 'graphql-tag';
import {
  EventNotificationItemInput,
  EventsOperation,
  GetAzzurroEventsConfigurationByPlantIdQuery,
  GetAzzurroEventsConfigurationListQuery,
  ManageAzzurroEventMutation,
} from 'ngx-core-services';

import {
  AZZURRO_EVENT_CONFIGURATION_LIST_FRAGMENT,
  EVENT_NOTIFICATION_BY_PLANTID_FRAGMENT,
  EVENT_NOTIFICATION_CONFIG_FRAGMENT,
} from './notification-configuration.queries';

@Injectable({
  providedIn: 'root'
})
export class NotificationConfigurationService {
  constructor(
    private readonly getAzzurroEventsConfigurationListQuery: GetAzzurroEventsConfigurationListQuery,
    private readonly manageAzzurroEventMutation: ManageAzzurroEventMutation,
    private readonly getAzzurroEventsConfigurationByPlantIdQuery: GetAzzurroEventsConfigurationByPlantIdQuery,
  ) { }

  async getAzzurroEventsConfigurationList() {
    return (await this.getAzzurroEventsConfigurationListQuery.execute(
      gql`${AZZURRO_EVENT_CONFIGURATION_LIST_FRAGMENT}`,
      true
    )).data.getAzzurroEventsConfigurationList;
  }

  async manageAzzurroEvent(
    plantId: string,
    emails: string[],
    events?: EventNotificationItemInput,
    eventsOperation: EventsOperation = EventsOperation.update,
  ) {
    const response = await this.manageAzzurroEventMutation.execute(
      gql`${EVENT_NOTIFICATION_CONFIG_FRAGMENT}`,
      { plantId, input: { emails, events, eventsOperation } }
    );
    return response;
  }

  async getAzzurroEventsConfigurationByPlantId(plantId: string) {
    return (await this.getAzzurroEventsConfigurationByPlantIdQuery.execute(
      gql`${EVENT_NOTIFICATION_BY_PLANTID_FRAGMENT}`,
      { plantId },
      true
    )).data.getAzzurroEventsConfigurationByPlantId;
  }

  async deletePlantEventConfigurations(plantId: string, events: EventNotificationItemInput) {
    return this.manageAzzurroEventMutation.execute(
      gql`${EVENT_NOTIFICATION_CONFIG_FRAGMENT}`,
      { plantId, input: { events, eventsOperation: EventsOperation.delete } }
    );
  }
}
